var componentRequireContext = require.context("components", true, /front\/simulator\/*/);
var ReactRailsUJS = require("react_ujs");
ReactRailsUJS.useContext(componentRequireContext);